import React from 'react';
import styled from 'styled-components';
import * as types from '../../actions/actionTypes';

import PatternCard from '../pattern/SmallPatternCard';
import InternalLink from '../InternalLink';

const NewestPatternGalleryStripe = ({ columns, patterns, sewpatId }) => {
    const singleColCSS = 'minmax(75px, 1fr)';

    const getColCSS = () => {
        var colCSS = '';
        for (var i = 0; i < columns; i++) {
            colCSS = `${colCSS} ${singleColCSS}`;
        }
        return colCSS;
    };

    const getPatterns = () => {
        var Patterns = [];
        for (var i = 0; i < columns; i++) {
            const LinkProps = {
                type: types.NAVIGATED_TO_NEWEST_PATTERNGALLERY,
                payload: {
                    sewpatId,
                },
            };
            Patterns.push(
                <InternalLink to={LinkProps} >
                    <PatternCard
                        caption={`${patterns[i][0]}: ${patterns[i][1].title}`}
                        src={patterns[i][1].thumbnails.gallery.url}
                    />
                </InternalLink>);
        }
        return Patterns;
    };

    const StyledPatternGalleryNewestStripe = styled.div`
        display: grid;
        grid-template-columns: ${getColCSS()};
        grid-column-gap: ${props => props.theme.space[6]};
    `;

    return (
        <StyledPatternGalleryNewestStripe>
            {getPatterns()}
        </StyledPatternGalleryNewestStripe>
    );
};

export default NewestPatternGalleryStripe;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/NewestPatternGalleryStripe.js